/* Strong Magnets – custom.js v4.0 */

/* ── 1. POPUP: 8s delay + exit-intent ─────────────────────────────── */
(function(){
  var _orig=window.setTimeout,patched=false;
  window.setTimeout=function(fn,delay){
    if(!patched&&typeof delay==='number'&&delay>=25000&&delay<=60000){patched=true;delay=8000;}
    return _orig.apply(this,arguments);
  };
  document.addEventListener('mouseleave',function h(e){
    if(e.clientY>0)return;
    var pop=document.getElementById('smNp');
    if(!pop||!pop.hidden)return;
    pop.hidden=false;void pop.offsetWidth;
    pop.classList.add('is-open');
    document.body.style.overflow='hidden';
    document.removeEventListener('mouseleave',h);
  });
})();

/* ── 2. HIDE "Save 0%" BADGES ──────────────────────────────────────── */
(function(){
  function fix(){
    document.querySelectorAll('[data-badge-sales]').forEach(function(badge){
      var span=badge.querySelector('[data-price-percent-saved]');
      if(!span)return;
      badge.style.display=(!isNaN(parseInt(span.textContent,10))&&parseInt(span.textContent,10)>0)?'':'none';
    });
  }
  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',fix):fix();
  document.addEventListener('shopify:section:load',fix);
})();

/* ── 3. STICKY MOBILE ADD-TO-CART ──────────────────────────────────── */
(function(){
  if(window.innerWidth>768)return;
  if(!document.querySelector('form[action*="/cart/add"]'))return;
  var s=document.createElement('style');
  s.textContent='.sm-atcbar{position:fixed;bottom:0;left:0;right:0;z-index:9000;background:#fff;border-top:1px solid #e5e7eb;padding:12px 16px 16px;display:flex;gap:10px;align-items:center;box-shadow:0 -4px 16px rgba(0,0,0,.08);}'
    +'.sm-atcbar__price{font-weight:600;font-size:14px;color:#1f2933;white-space:nowrap;}'
    +'.sm-atcbar__btn{flex:1;height:50px;background:#054fee;color:#fff;border:0;border-radius:10px;font-size:15px;font-weight:600;cursor:pointer;}';
  document.head.appendChild(s);
  var mainBtn=document.querySelector('form[action*="/cart/add"] [name="add"]');
  if(!mainBtn)return;
  var priceEl=document.querySelector('[data-price],.product__price .money,.price .money');
  var bar=document.createElement('div');
  bar.className='sm-atcbar';
  bar.innerHTML='<span class="sm-atcbar__price">'+(priceEl?priceEl.textContent.trim():'')+'</span>'
    +'<button class="sm-atcbar__btn" type="button">In den Warenkorb</button>';
  document.body.appendChild(bar);
  bar.querySelector('.sm-atcbar__btn').addEventListener('click',function(){mainBtn.click();});
  new IntersectionObserver(function(e){bar.style.display=e[0].isIntersecting?'none':'';},{threshold:0.5}).observe(mainBtn);
})();

/* ── 4. ROTATING TRUST BAR ─────────────────────────────────────────── */
(function(){
  var msgs=[
    '\u2713 Versand aus Deutschland \u00b7 2\u20134 Werktage',
    '\u2713 \u00dcber 200.000 zufriedene Kunden',
    '\u2713 Trusted Shops K\u00e4uferschutz',
    '\u2713 Sicher bezahlen \u2013 PayPal \u00b7 Klarna \u00b7 Visa \u00b7 Mastercard',
    '\u2713 30 Tage R\u00fcckgabe \u2013 keine Fragen'
  ];
  var bar=document.createElement('div');
  bar.id='sm-trust-bar';
  var inner=document.createElement('div');
  inner.style.cssText='font-size:13px;font-weight:500;color:#fff;text-align:center;padding:8px 16px;transition:opacity .4s;';
  bar.style.cssText='background:#054fee;overflow:hidden;';
  bar.appendChild(inner);
  var idx=0;
  function show(i){inner.style.opacity='0';setTimeout(function(){inner.textContent=msgs[i%msgs.length];inner.style.opacity='1';},400);}
  show(0);
  setInterval(function(){idx++;show(idx);},3500);
  var anchor=document.querySelector('.site-announcement,.site-header-wrapper');
  if(anchor&&anchor.parentNode){anchor.parentNode.insertBefore(bar,anchor);}else{document.body.prepend(bar);}
})();

/* ── 5. PREMIUM HERO: remove gap, tighten spacing ──────────────────── */
(function(){
  var style=document.createElement('style');
  style.textContent=[
    /* Kill default section top-padding on the very first visible section */
    '.main-content > .shopify-section:first-child { margin-top: 0 !important; padding-top: 0 !important; }',
    '.main-content > .shopify-section:first-child .section { padding-top: 0 !important; }',
    /* Tighten hero padding */
    '.sm-hero { padding-top: 48px !important; padding-bottom: 0 !important; }',
    /* Premium nav: slightly reduce nav bottom border gap */
    '.site-navigation-wrapper { border-bottom: 1px solid #e5e7eb; }',
    /* Remove any top margin on sm-root when it is the first section */
    '.shopify-section:first-child .sm-root { margin-top: 0; }',
    /* Ensure no extra whitespace from empty sections */
    '.shopify-section:empty { display: none; }',
    /* Premium typography: tighter heading on hero */
    '.sm-hero h1 { letter-spacing: -.03em; }'
  ].join('\n');
  document.head.appendChild(style);
})();

/* ── 6. SPEED: preconnect + LCP priority ───────────────────────────── */
(function(){
  var hints=[
    {rel:'preconnect',href:'https://cdn.shopify.com'},
    {rel:'preconnect',href:'https://fonts.googleapis.com'},
    {rel:'dns-prefetch',href:'https://integrations.etrusted.com'}
  ];
  hints.forEach(function(h){
    if(document.querySelector('link[href="'+h.href+'"]'))return;
    var l=document.createElement('link');
    l.rel=h.rel;l.href=h.href;
    document.head.prepend(l);
  });
  document.addEventListener('DOMContentLoaded',function(){
    var heroImg=document.querySelector('.sm-hero img,.featured-product__image img,[data-rimg]:first-of-type');
    if(heroImg){heroImg.setAttribute('fetchpriority','high');heroImg.setAttribute('loading','eager');}
  });
})();
